import React, { Component } from "react";
import { WithStyles, createStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import * as LZString from 'lz-string';

const styles = (theme: Theme) =>
  createStyles({

  });

//@ts-ignore
interface PDFViewerProps extends WithStyles<typeof styles> {
    url: any;
    onPageChange: Function;
    onDocumentLoad: Function;
    password: string;
}

interface PDFViewerStates {
    pdfUrl: string;
}

class PDFViewer extends Component<PDFViewerProps, PDFViewerStates> {
  constructor(props: PDFViewerProps) {
    super(props);
    this.state= {
        pdfUrl: ''
    }
  }

  componentDidMount() {
    const { url } = this.props; 
    const pdfl = typeof(url) === 'string'? url :  URL.createObjectURL(url);;
    this.setState({ pdfUrl:pdfl});
  }
  componentDidUpdate(prevProps: any) {
    const { url } = this.props;

    if (url !== prevProps.url) {
      // Only update state if `data` prop changes
      const pdfl = typeof(url) === 'string'? url :  URL.createObjectURL(url);;
      this.setState({ pdfUrl:pdfl});
    }
  }
  
  handleAskPassword = (e: any) => {
    e.verifyPassword(LZString.decompressFromEncodedURIComponent(this.props.password));
  };

  render() {
    const { pdfUrl } = this.state;
    return (
        <>{pdfUrl !== '' && (
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
            <div style={{height:'500px',width: '100%' }}>
            <Viewer
              fileUrl={pdfUrl}
              onDocumentAskPassword={this.handleAskPassword}
              onPageChange={(e) => this.props.onPageChange(e)}
              onDocumentLoad={(e) => this.props.onDocumentLoad(e)}
              />
            </div>
        </Worker>
        )}
        </>

    );
  }
}

// @ts-ignore
export default withStyles(styles)(PDFViewer);